import investmentProgramsReducer from "./investmentProgramsReducer";

export * from "./investmentProgramsReducer";
export default investmentProgramsReducer;
